<template>
  <div class="page padding">
    <b-card no-body>
      <div class="p-3">
        <h3 class="mb-3">{{ nombreProductor }}</h3>
        <hr />
        <b-form>
          <b-form-group label="Entidad Bancaria">
            <autocomplete
              :data="bancos"
              input-class="form-control"
              @selected="setBanco"
              :placeholder="cuenta.banco.length ? cuenta.banco : 'Buscar banco ...'"
              :loading="!bancos"
              loadingCaption="Cargando bancos ..."
              @blur="$v.cuenta.banco.$touch"
              :state="$v.cuenta.banco.$dirty ? !$v.cuenta.banco.$error : null"
            ></autocomplete>
          </b-form-group>
          <b-form-group label="Titular">
            <b-form-input
              v-model="cuenta.titular"
              @blur="$v.cuenta.titular.$touch"
              :state="$v.cuenta.titular.$dirty ? !$v.cuenta.titular.$error : null"
            />
          </b-form-group>
          <b-form-group label="CUIT">
            <b-form-input
              v-model="cuenta.cuit"
              @blur="$v.cuenta.cuit.$touch"
              :state="$v.cuenta.cuit.$dirty ? !$v.cuenta.cuit.$error : null"
            />
          </b-form-group>
          <b-row>
            <b-col sm="7">
              <b-form-group label="Nro. de Cuenta">
                <b-form-input
                  v-model="cuenta.numero"
                  @blur="$v.cuenta.numero.$touch"
                  :state="$v.cuenta.numero.$dirty ? !$v.cuenta.numero.$error : null"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Tipo de Cuenta">
                <b-form-select
                  v-model="cuenta.tipo"
                  :options="['Cuenta Corriente', 'Caja Ahorro', 'Sin datos Tipo Cuenta']"
                  @blur="$v.cuenta.tipo.$touch"
                  :state="$v.cuenta.tipo.$dirty ? !$v.cuenta.tipo.$error : null"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Moneda">
                <b-form-select
                  v-model="cuenta.moneda"
                  :options="monedas"
                  @blur="$v.cuenta.moneda.$touch"
                  :state="$v.cuenta.moneda.$dirty ? !$v.cuenta.moneda.$error : null"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="CBU">
            <b-form-input
              v-model="cuenta.cbu"
              @blur="$v.cuenta.cbu.$touch"
              :state="$v.cuenta.cbu.$dirty ? !$v.cuenta.cbu.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <b-card-footer>
        <b-row>
          <b-col sm="6">
            <b-button class="btn-action" @click="getDatosBancarios" title="Deshacer todos los cambios">
              <i class="fa fa-undo"></i> Reset
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button class="btn-action" variant="success" @click="sendUpdate" :disabled="sending">
              <i class="fa fa-send-o" v-if="!sending"></i>
              <i class="fa fa-spinner fa-spin" v-else></i>
              &nbsp;Informar Actualización
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete';
import { required, numeric } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Autocomplete
  },
  data() {
    return {
      sending: false,
      bancos: [],
      cuenta: {
        banco: '',
        titular: '',
        cuit: '',
        numero: '',
        tipo: '',
        cbu: '',
        moneda: '',
        email_pas: '',
      }
    };
  },
  validations: {
    cuenta: {
      banco: { required },
      titular: { required },
      cuit: { required, numeric },
      numero: { required },
      tipo: { required },
      moneda: { required },
      cbu: { required, numeric }
    }
  },
  methods: {
    ...mapActions(['getMonedas', 'getTiposCuenta']),
    getBancos() {
      this.$api('tablas/bancos').then(res => {
        this.bancos = res.data.map(item => {
          return {
            text: item.txt_nombre,
            value: item.cod_banco
          };
        });
      });
    },
    setBanco(banco) {
      this.cuenta.banco = banco.text;
    },
    getDatosBancarios() {
      const cod_agente = this.$store.state.auth.cod_agente;
      this.$api('pas/datos-bancarios/' + cod_agente).then(res => {
        this.cuenta = res.data[0];
      });
    },
    sendUpdate: async function() {
      this.$v.cuenta.$touch();

      if (this.$v.cuenta.$invalid) {
        this.$toast.error('Los datos ingresados son inválidos.');
        return null;
      }

      this.sending = true;
      const cod_agente = this.$store.state.auth.cod_agente;
      const nombre = (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null','');
      this.cuenta.email_pas = this.$store.state.auth.email
      await this.$api
        .post(`pas/datos-bancarios/${cod_agente}/${nombre}`, this.cuenta)
        .then(res => {
          this.$toast.success(res.data);
        })
        .catch(err => {
          const errors = err.response.data.errors;
          if (errors && Object.values(errors).length) {
            this.$toast.error('Los datos ingresados son inválidos.');
          }
        });
      this.sending = false;
    }
  },
  computed: {
    nombreProductor() {
      return this.$store.getters['NOMBRE_PRODUCTOR'];
    },
    ...mapGetters(['monedas', 'tiposCuenta'])
  },
  created() {
    this.getMonedas()
    this.getTiposCuenta()
    this.getBancos();
    this.getDatosBancarios();
  }
};
</script>

<style scoped>

@media (max-width: 768px) {
  .btn-action {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
